document.addEventListener('DOMContentLoaded', function() {
  const signupForm = document.querySelector('#new_client');

  if (signupForm) {
    // triggered when /clients/sign_up form is submitted
    signupForm.addEventListener('submit', function(event) {

      gtag('event', 'form_submitted', {
        'event_category': 'Client Signup',
        'event_label': 'Client Signup Form (Attempt)',
        'form_id': signupForm.id || 'unknown_form' // Pass relevant data
      });
    });
  }
});

document.addEventListener('turbolinks:load', function() {
  // Check the global flag. If true, it means this 'turbolinks:load' is for the initial page load.
  if (window.ga_initial_page_view_fired) {
    // The page view has already been sent by the inline script in the partial.
    // Reset the flag to false, so subsequent *actual* Turbolinks navigations will trigger a page_view.
    window.ga_initial_page_view_fired = false;
    // console.debug('Turbolinks:load detected initial page load. Skipping duplicate page_view.');
    return;
  }

  // Check if gtag and your standardization functions are defined and accessible globally
  if (typeof gtag === 'function' &&
      typeof window.standardizeGaPageViewData === 'function' &&
      typeof window.getTenantName === 'function') {

    const turbolinksStandardizedData = window.standardizeGaPageViewData(window.location.pathname, document.title);
    const tenantIdentifier = window.getTenantName();

    const pageViewParams = {
      'page_path': turbolinksStandardizedData.path,
      'page_location': window.location.href,
      'page_title': turbolinksStandardizedData.title,
      'tenant_name': tenantIdentifier
    };

    // console.debug('Turbolinks Page View Event Parameters:', pageViewParams);
    gtag('event', 'page_view', pageViewParams);
  }
});
